const MESSAGES = {
  ADD_PRODUCT_SUCCESS_MESSAGE: 'Succeed to add the product!',
  ADD_PRODUCT_FAILED_MESSAGE: 'Failed to add the product!',
  DELETE_PRODUCT_SUCCESS_MESSAGE: 'Succeed to delete the product!',
  DELETE_PRODUCT_FAILED_MESSAGE: 'Failed to delete the product!',
  GET_PRODUCT_FAILED_MESSAGE: 'Failed to load products!',
  EDIT_PRODUCT_SUCCESS_MESSAGE: 'Succeed to edit the product!',
  EDIT_PRODUCT_FAILED_MESSAGE: 'Failed to edit the product!',
  NOT_FOUND: 'No Results Found!',
  ADD_PRODUCT_HEADING: 'Create a new product',
  EDIT_PRODUCT_HEADING: 'Edit product',
  GENERAL_ERROR_MESSAGE:
    'An unexpected error occurred. Please try again later!',
};

export { MESSAGES };
